var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 9.91467C36 15.3904 31.5694 19.8293 26.1041 19.8293C20.6387 19.8293 16.2081 15.3904 16.2081 9.91467C16.2081 4.43895 20.6387 0 26.1041 0C31.5694 0 36 4.43895 36 9.91467Z",
    fill: "#F79F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7919 9.91467C23.7919 15.3904 19.3613 19.8293 13.8959 19.8293C8.43056 19.8293 4 15.3904 4 9.91467C4 4.43895 8.43056 0 13.8959 0C19.3613 0 23.7919 4.43895 23.7919 9.91467Z",
    fill: "#EA001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.10974C17.691 3.92479 16.2089 6.74528 16.2089 9.91371C16.2089 13.0821 17.691 15.9048 20 17.7198C22.3089 15.9048 23.7911 13.0821 23.7911 9.91371C23.7911 6.74528 22.3089 3.92479 20 2.10974Z",
    fill: "#FF5F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.5524de32.svg";
export { ForwardRef as ReactComponent };